import { render, staticRenderFns } from "./order-detail-xl.vue?vue&type=template&id=6cb5dcb6&scoped=true&"
import script from "./order-detail-xl.vue?vue&type=script&lang=js&"
export * from "./order-detail-xl.vue?vue&type=script&lang=js&"
import style0 from "./order-detail-xl.vue?vue&type=style&index=0&id=6cb5dcb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb5dcb6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cb5dcb6')) {
      api.createRecord('6cb5dcb6', component.options)
    } else {
      api.reload('6cb5dcb6', component.options)
    }
    module.hot.accept("./order-detail-xl.vue?vue&type=template&id=6cb5dcb6&scoped=true&", function () {
      api.rerender('6cb5dcb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/order-manager/order-detail-xl.vue"
export default component.exports